import React from 'react';
import { Switch, Route } from 'react-router-dom';

import List from './List';
import Edit from './Edit';

export default () => (
	<Switch>
		<Route path="/admin/appointments" exact component={List} />
		{/*<Route path="/admin/appointments/create" component={Edit} />*/}
		<Route path="/admin/appointments/:id" component={Edit} />
	</Switch>
);
